// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__2N2Dj","icon":"alert_icon__3EdJU","success":"alert_success__h4kO2","danger":"alert_danger__1Wbni"};